import { HEADLINE_TIME_PERIOD } from '../constants';

const isHeadlineTime = (time: number) => {
  const serverTime = new Date(time);

  const hours = serverTime.getUTCHours();
  const minutes = serverTime.getUTCMinutes();

  return (
    hours === HEADLINE_TIME_PERIOD.hour &&
    minutes >= HEADLINE_TIME_PERIOD.startMinute &&
    minutes < HEADLINE_TIME_PERIOD.endMinute
  );
};

export { isHeadlineTime };
